import { cn, Label, Switch } from "@tellescope/ui";
import { useTranslation } from "react-i18next";
import { useShallowTimelineSettingsStore } from "../../../../store";
import { useAuth } from "@tellescope/tanstack-query";

export interface TimelineSettingsRowProps {
  className?: string;
}

export const TimelineSettingsRow = ({ className }: TimelineSettingsRowProps) => {
  const { t } = useTranslation("timeline");
  const { currentUser } = useAuth();
  const { userSettings, setUserSetting } = useShallowTimelineSettingsStore("userSettings", "setUserSetting");
  const combineSMSEntries = userSettings[currentUser.id]?.combineAllSMSItems;

  return (
    <div className={cn("flex gap-2 justify-end items-center flex-shrink", className)}>
      <Label htmlFor="combine-sms-entries" className="font-normal">
        {t("Combine SMS Items")}
      </Label>
      <Switch
        id="combine-sms-entries"
        checked={combineSMSEntries}
        onCheckedChange={(checked) => setUserSetting(currentUser.id, "combineAllSMSItems", checked)}
      />
    </div>
  );
};
